module.exports = __webpack_public_path__ + "static/TlwgTypewriter-7ccd800f403dd48686a01c64e40baf9e.woff2";